module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "card-item borrow"
  }, [_c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.info.productName))]), _vm._v(" "), (_vm.info.isRP) ? _c('router-link', {
    staticClass: "repaymentplan",
    attrs: {
      "to": ("/user/order/" + _vm.orderNo + "/repaymentplan")
    }
  }, [_vm._v("还款计划")]) : _vm._e()], 1), _vm._v(" "), (_vm.info.signDate) ? _c('p', {
    staticClass: "sign-date"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("签约日期：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.signDate))])]) : _vm._e(), _vm._v(" "), (_vm.info.hasAutho == 1) ? _c('p', {
    staticClass: "is-bind-card"
  }, [_c('span', [_vm._v("·已綁定还款卡")])]) : _vm._e(), _vm._v(" "), (_vm.info.borrowMoney) ? _c('p', {
    staticClass: "money"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("借款金额：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.borrowMoney) + "元")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [(_vm.info.interestRate) ? _c('p', {
    staticClass: "rate half"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("借款月利率：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.interestRate) + "%")])]) : _vm._e(), _vm._v(" "), (_vm.info.interest) ? _c('p', {
    staticClass: "money half"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("借款利息：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.interest) + "元")])]) : _vm._e()]), _vm._v(" "), (_vm.info.duration) ? _c('p', {
    staticClass: "duration"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("借款期限：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.duration) + _vm._s(_vm.info.unit))])]) : _vm._e(), _vm._v(" "), (_vm.info.loanMoney) ? _c('p', {
    staticClass: "money"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("贷款金额：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.loanMoney) + "元")])]) : _vm._e(), _vm._v(" "), (_vm.info.loanBank) ? _c('p', {
    staticClass: "bank"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("申贷银行：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.loanBank))])]) : _vm._e(), _vm._v(" "), (_vm.info.loanCardNo) ? _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("放款卡号：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.loanCardNo))])]) : _vm._e(), _vm._v(" "), (_vm.info.loanCardName) ? _c('p', {
    staticClass: "name"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("放款卡户名：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.loanCardName))])]) : _vm._e(), _vm._v(" "), (_vm.info.loanCardBank) ? _c('p', {
    staticClass: "bank"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("放款卡开户行：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.loanCardBank))])]) : _vm._e(), _vm._v(" "), (_vm.info.loanDate) ? _c('p', {
    staticClass: "date"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("放款日期：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.loanDate))])]) : _vm._e(), _vm._v(" "), (_vm.info.startRepaymentTime) ? _c('p', {
    staticClass: "date"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("预计还款时间：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.startRepaymentTime))])]) : _vm._e(), _vm._v(" "), (_vm.info.successRepaymentTime) ? _c('p', {
    staticClass: "date"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("实际还款时间：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.successRepaymentTime))])]) : _vm._e(), _vm._v(" "), (_vm.info.housePro) ? _c('p', {
    staticClass: "pro"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("房屋属性：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.housePro))])]) : _vm._e(), _vm._v(" "), (_vm.info.houseAddr) ? _c('p', {
    staticClass: "addr"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("房屋地址：")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.info.houseAddr))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [(_vm.isFI) ? _c('button', {
    staticClass: "btn btn-action",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isPerfectInfo = true
      }
    }
  }, [_vm._v("完善借款信息")]) : _vm._e(), _vm._v(" "), (_vm.info.isAutho) ? _c('router-link', {
    staticClass: "btn btn-action",
    attrs: {
      "to": ("/user/order/" + _vm.orderNo + "/authorization")
    }
  }, [_vm._v(_vm._s(_vm.info.authoName))]) : _vm._e()], 1)]), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPerfectInfo),
      expression: "isPerfectInfo"
    }],
    staticClass: "perfectInfoConfirm"
  }, [_c('div', {
    staticClass: "modal-backdrop"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "dialog-bd"
  }, [_c('div', {
    staticClass: "dialog-msg-container"
  }, [_vm._v(_vm._s(_vm.info.productName) + "需要获取您的手机通讯录，请通过融资专家APP提交您的手机通讯录信息。")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-ft"
  }, [_c('a', {
    staticClass: "dialog-btn default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    staticClass: "dialog-btn primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("下载融资专家APP")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63818439!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/order-detail.vue
// module id = 357
// module chunks = 1